{
  "page_title": "Ihr Profil",
  "profile": {
    "title": "Profil",
    "personal_information": "Profil",
    "account_information": "Konto",
    "notifications": "Benachrichtungen",
    "change_password": "Sicherheit",
    "delete_account": "Account löschen",
    "address_form_title": "Adresse",
    "general_form_title": "Allgemein",
    "page": {
      "personal_information": {
        "title": "Persönliche Informationen",
        "section_info": "Allgemein:",
        "section_address": "Adresse:",
        "update_success": "Persönliche Informationen wurden aktualisiert",
        "edit": "In Bearbeitung..."
      }
    },
    "error": {
      "invalid_credentials": "Falsches Passwort",
      "duplicate_email": "E-Mail Adresse ist bereits registriert"
    },
    "unsaved_form_question": "Ihre Änderungen sind nicht gespeichert, sind Sie sicher?",
    "label": {
      "first_name": "Vorname",
      "middle_name": "Mittlerer Name",
      "last_name": "Nachname",
      "email_address": "E-Mail Adresse",
      "country_code": "Land",
      "phone_number": "Telefonnummer",
      "address_line_1": "Adresszeile 1",
      "address_line_2": "Adresszeile 2",
      "address_line_3": "Adresszeile 3",
      "postal_code": "PLZ",
      "city": "Ort",
      "state": "Bundesland",
      "country": "Land",
      "current_password": "Momentanes Passwort",
      "new_password": "Neues Passwort",
      "verify_password": "Passwort wiederholen",
      "language": "Sprache"
    },
    "language": {
      "en": "Englisch",
      "de": "Deutsch"
    },
    "buttons": {
      "submit_form": "Speichern",
      "cancel_form": "Abbrechen"
    },
    "validation": {
      "_common": {
        "trailing_whitespace": "Leerzeichen am Ende sind nicht erlaubt",
        "beginning_whitespace": "Leerzeichen am Anfang sind nicht erlaubt"
      },
      "firstName": {
        "empty": "Vorname ist verpflichtend anzugeben",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "middleName": {
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "lastName": {
        "empty": "Nachname ist verpflichtend anzugeben",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "email": {
        "empty": "E-Mail Adresse ist verpflichtend anzugeben",
        "duplicate_email": "E-Mail Adresse ist bereits registriert",
        "invalid_email": "Geben Sie eine gültige E-Mail Adresse ein",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "phoneNationalNumber": {
        "invalid_number_string": "Geben Sie eine gültige Telefonnummer ein",
        "min_digits": "{{country}} Telefonnummern müssen mindestens {{min}} Ziffern haben",
        "max_digits": "{{country}} Telefonnummern dürfen höchstens {{max}} Ziffern haben",
        "exact_digits": "{{country}} Telefonnummern müssen genau {{min}} Ziffern haben",
        "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
        "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
      },
      "phoneCountryCode": {
        "empty": "Wählen Sie eine Vorwahl aus"
      },
      "oldPassword": {
        "empty": "Geben Sie ihr momentanes Passwort ein",
        "invalid_password": "Das Passwort muss mindestens 8 Zeichen enthalten, davon einen Kleinbuchstaben, einen Großbuchstaben und eine Ziffer"
      },
      "newPassword": {
        "empty": "Geben Sie ihr neues Passwort ein",
        "invalid_password": "Das Passwort muss mindestens 8 Zeichen enthalten, davon einen Kleinbuchstaben, einen Großbuchstaben und eine Ziffer"
      },
      "newPasswordConfirm": {
        "empty": "Erneut neues Passwort eingeben",
        "no_match": "Passwörter stimmen nicht überein"
      },
      "address": {
        "line1": {
          "empty": "Adresszeile 1 ist verpflichtend anzugeben",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "line2": {
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "line3": {
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "postalCode": {
          "empty": "ZIP / Postleitzahl ist verpflichtend anzugeben",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "city": {
          "empty": "Stadt ist verpflichtend anzugeben",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "state": {
          "empty": "Bundesland ist verpflichtend anzugeben",
          "trailing_whitespace": "$t(profile.validation._common.trailing_whitespace)",
          "beginning_whitespace": "$t(profile.validation._common.beginning_whitespace)"
        },
        "countryCode": {
          "empty": "Land ist verpflichtend anzugeben"
        }
      }
    }
  },
  "organizations": {
    "title": "Organisationen",
    "submenu": {
      "title": "Meine Organisationen",
      "create": "Erstellen",
      "assigned_organizations": "Zugeteilte Organisationen",
      "empty": "Keine Organisationen"
    },
    "page": {
      "empty": {
        "title": "Keine Organisationen vorhanden",
        "subtitle": "Organisation erstellen",
        "body": "Hier können Sie sämtliche Organisationen in denen Sie Mitglied sind einsehen.<br><hr><br>Um eine neue Organisation zu erstellen, benutzen Sie bitte den Erstellen Knopf."
      },
      "select": {
        "title": "Organisations Information",
        "subtitle": "",
        "body": "Wählen Sie eine Organisation aus um deren Details anzusehen"
      },
      "header": {
        "title": "{{organization}}",
        "subtitle": "Rolle:",
        "admin_action": "Admin",
        "edit": "In Bearbeitung...",
        "details": "Allgemein:",
        "address": "Adresse:"
      }
    },
    "modal": {
      "message": "Sind Sie sicher, dass Sie die Organisation {{organizationName}} verlassen möchten?",
      "leave": "Verlassen",
      "cancel": "Abbrechen"
    }
  },
  "notifications": {
    "screen_title": "Wählen Sie wie Sie Benachrichtungen empfangen wollen",
    "group_name": {
      "first_party_clusters": "1st Party Cluster",
      "first_party_clusters_tooltip": "Cluster die von Ihnen erstellt wurden",
      "second_party_clusters": "2nd Party Cluster",
      "second_party_clusters_tooltip": "Clusters die in einer Ihrer Organisationen erstellt wurden"
    },
    "notification_type": {
      "web_and_mobile": "Web & Mobil",
      "email": "E-Mail"
    },
    "label": {
      "changes_saved": "Änderungen gespeichert",
      "receive_notifications": "Benachrichtigungen erhalten"
    },
    "notification_name": {
      "cluster_created": "Cluster erstellt",
      "cluster_updated": "Cluster geändert",
      "cluster_deleted": "Cluster gelöscht",
      "cluster_unavailable": "Cluster nicht verfügbar"
    }
  },
  "invitations": {
    "title": "Einladungen",
    "list_heading": "Meine Einladungen",
    "no_invitations": "Keine Einladungen vorhanden",
    "page": {
      "empty": {
        "title": "Keine Einladungen",
        "subtitle": "",
        "body": "Sie haben keine ausstehenden Einladungen"
      },
      "select": {
        "title": "Sie haben ausstehende Einladungen",
        "subtitle": "",
        "body": "Wählen Sie links eine Organisation aus um die Details zu sehen."
      },
      "header": {
        "title": "{{organization}}",
        "subtitle": "",
        "form_section_details": "Allgemein:",
        "form_section_address": "Adresse:",
        "get_organization_error": "Die Organisation wurde nicht gefunden",
        "error_submit": "Ein Fehler ist aufgetreten. Ihre Einladungen konnte nicht angenommen/abgelehnt werden.",
        "modal_title": "Ausstehende Einladung",
        "modal_content_text": "Einladung ",
        "modal_content_textaccept": "Einladung annehmen",
        "modal_content_textreject": "Einladung ablehnen"
      }
    },
    "label": {
      "you_are_invited_to": "Sie wurden eingeladen zu",
      "invited_by": "Eingeladen von",
      "your_organizations": "Ihre Organisationen",
      "role": "Rolle"
    }
  },
  "delete_account": {
    "title": "Account löschen",
    "warning": "Eine Accountlöschung kann NICHT rückgängig gemacht werden. Sind Sie sich sicher?",
    "button_text": "Account löschen"
  },
  "delete_image": {
    "title": "Bild löschen",
    "confirm_delete_image": "Sind Sie sicher, dass Sie Ihr Profilbild löschen möchten?"
  }
}
